// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"b9d300a7","container":"a24c19a5","iconTick":"b340fa1f"};